import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ReactionsService } from './reactions.service';
import { Reactions, ReactionsClass, ReactionsResponse, ReactionType } from './interfaces/reactions.interface';
import { HomeService } from 'src/app/source/features/home/services/home.service';

@Component({
  selector: 'app-reactions',
  templateUrl: './reactions.component.html',
  styleUrls: ['./reactions.component.scss']
})
export class ReactionsComponent implements OnInit {

  public reactionsService = inject(ReactionsService);
  public homeService = inject(HomeService);


  @Input() reactions: Reactions;


  public userReaction: string;
  public showEmojiBar: boolean = false;

  ngOnInit() {
    this.userReaction = this.reactions?.user_reaction || null;
  }



  private getReactions(): void {
    this.reactionsService.getReactions(this.reactions.post_id).subscribe({
      next: (response: any) => {
        if (response?.reactions) {
          if (response) {
            this.reactions = {
              post_id: response.post_id,
              user_reaction: response.user_reaction,
              news_reactions: response.reactions
            };
          }

          if (response?.user_reaction) {
            this.userReaction = response.user_reaction;
          }

          const cachedHomeData = this.homeService.getCachedHomeData();

          if (cachedHomeData && cachedHomeData.news) {
            const newsIndex = cachedHomeData.news.findIndex(newsItem => newsItem.ID.toString() === response.post_id);

            if (newsIndex !== -1) {
              const updatedNews = [...cachedHomeData.news];

              updatedNews[newsIndex] = {
                ...updatedNews[newsIndex],
                user_reaction: response.user_reaction,
                post_reactions: response.reactions
              };

              this.homeService.updateHomeDataCache({
                ...cachedHomeData,
                news: updatedNews
              });
            }
          }
        }
      },
      error: (err) => {
        console.error('Error al obtener las reacciones actualizadas:', err);
      }
    });
  }


  get totalReactions(): number {
    if (!this.reactions || !this.reactions.news_reactions) return 0;

    return Object.values(this.reactions.news_reactions).reduce((acc, val) => acc + val, 0);
  }


  saveReaction(reactionType: ReactionType) {
    //Aquí si pulsas la misma reacción que tienes, la borras enviando un vacio ''
    const reactionToSend = this.userReaction === reactionType ? '' : reactionType;

    this.reactionsService.saveReaction(this.reactions.post_id, reactionToSend).subscribe({
      next: () => {
        this.userReaction = reactionToSend === '' ? null : reactionType;
        this.closeEmojiBar();
        this.getReactions();

      },
      error: (err) => {
        console.error('❌ Error al guardar la reacción:', err);
      }
    });
  }

  getReactionImage(): string {
    const basePath = './../../../../../assets/icons/reactions/';

    // Si no hay reacción, usar imagen gris
    if (!this.userReaction) {
      return basePath + 'like_gris.png';
    }

    const reaction = this.userReaction.trim().toLowerCase();

    const imageMap: Record<string, string> = {
      like: 'like_azul.png',
      love: 'corazon_rojo.png',
      haha: 'emoji_risa.png',
      wow: 'emoji_sorpresa.png',
      sad: 'emoji_triste.png'
    };

    const imageName = imageMap[reaction];

    if (!imageName) {
      return basePath + 'like_gris.png';
    }

    return basePath + imageName;
  }


  //Filtra las reacciones para mostrar solo las dos primeras en las cards
  get firstTwoReactions(): { type: keyof ReactionsClass, count: number, img: string, alt: string }[] {
    const basePath = './../../../../../assets/icons/reactions/';
    const imageMap: Record<keyof ReactionsClass, string> = {
      like: 'like_azul.png',
      love: 'corazon_rojo.png',
      haha: 'emoji_risa.png',
      wow: 'emoji_sorpresa.png',
      sad: 'emoji_triste.png'
    };
    const altMap: Record<keyof ReactionsClass, string> = {
      like: 'Like',
      love: 'Love',
      haha: 'Haha',
      wow: 'Wow',
      sad: 'Sad'
    };

    return Object.entries(this.reactions.news_reactions)
      .filter(([_, count]) => count > 0)
      .slice(0, 2)
      .map(([type, count]) => ({
        type: type as keyof ReactionsClass,
        count: count as number,
        img: basePath + imageMap[type as keyof ReactionsClass],
        alt: altMap[type as keyof ReactionsClass]
      }));
  }

  closeEmojiBar() {
    this.showEmojiBar = false;
  }





}
